import React, { useCallback } from "react";
import "./Home.scss";
import nuferi from './assets/nufar-simplu.png'
import lotus from './assets/lotus.png'
import gradient from './assets/bg-gradient.png'
import homeBackground from './assets/background home.png'

import { useHistory } from "react-router-dom";

function Home() {
  const history = useHistory();
  const goToRoute = useCallback((path) =>  { history.push(path); }, [history]);

  return (
    <div className="main-container">
      <div id="main-area">
        <div className="title-desc">
        <span id="home-title">Ivris</span>
        <span id="home-desc">En checklista för att utveckla nya arbetssätt inom området välfardsteknik</span>
        </div>
       
        <div id="text-area">
        Ivris är en interaktiv och flexibel checklista som är tänkt att användas för att förbättra samverkan mellan olika aktörer (både professionella och slutanvändare) när en ny idé initieras inom området välfärdsteknik. Checklistan guidar dig genom flera steg och påminner samtidigt om viktiga aspekter att ta hänsyn till när du vidareutvecklar din idé (glöm inte olika användare, som medarbetare och slutanvändare, som kan även involveras i en eventuell referensgrupp). Ivris är ett pragmatiskt och serviceorienterat samarbetsverktyg som är möjligt att kombinera med befintliga resurser, metoder och riktlinjer.
<br/>Observera: använd gärna Google Chrome som webbläsare. 
        </div>
        <div id="controls-container">
        <button className="nav-btn" onClick={() => goToRoute('/checklista')} style={{width: '40%'}}>STARTA CHECKLISTAN</button>
          <button className="nav-btn" onClick={() => goToRoute('/introduktion')} style={{width: '40%'}}>INTRODUKTION</button>
          <button className="nav-btn" onClick={() => goToRoute('/hurfunkardet')} style={{width: '40%'}}>HUR FUNKAR DET</button>
        </div>

      </div>
      <img id="gradient"  height="100%" alt="alt" src={homeBackground}></img>

    </div>
  );
}

export default Home;
